import { styled } from '@mui/material';
import { GivelifyButton } from '../../button';

export const PaginationButton = styled(GivelifyButton)({
    width: '42px',
    height: '42px',
});
